<ul class="layout-tabmenu-nav">
    <li class="sidebar-group-clear">
        <span fxFlex="1 1 auto" *ngIf="selectedCurrency" [class]="flagIconClass(selectedCurrency)"></span>
    </li>
    <li class="sidebar-group">
        <mat-button-toggle-group #currencyToggleGroup="matButtonToggleGroup" (change)="onCurrencyChange($event)" [vertical]="true">
            <mat-button-toggle *ngFor="let currency of currencies" class="dashboardOptionSidebar" [value]="currency" [checked]="selectedCurrency === currency"
                [matTooltip]="'Switch to ' + currency" matTooltipPosition="right">
                <div fxLayout="column">
                    <!-- <span fxFlex="1 1 auto" [class]="flagIconClass(currency)"></span> -->
                    <span fxFlex="1 1 auto">{{currency}}</span>
                </div>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <li class="sidebar-group-clear">
        <mat-button-toggle-group #viewToggleGroup="matButtonToggleGroup" (change)="onViewChange($event)" [vertical]="true">
            <mat-button-toggle *ngFor="let viewSelection of viewSelections" class="dashboardOptionSidebar" [value]="viewSelection" [checked]="selectedViewSelection === viewSelection"
                [matTooltip]="'Switch view to ' + viewSelection.type" matTooltipPosition="right">
                <div fxLayout="column">
                    <!-- <span fxFlex="1 1 auto" [class]="flagIconClass(currency)"></span> -->
                    <span fxFlex="1 1 auto">{{viewSelection.type}}</span>
                </div>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <!-- <li class="sidebar-group">
        <mat-button-toggle-group #riskViewModeGroup="matButtonToggleGroup" (change)="onRiskViewModeChange($event)" [vertical]="true">
            <mat-button-toggle class="dashboardOptionSidebar" value="metric" [checked]="riskViewMode === RiskViewMode.METRIC" (click)="closeSideBar()"
                matTooltip="Risk Metric Dashboard" matTooltipPosition="right">
                <mat-icon>dashboard</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle class="dashboardOptionSidebar" value="chart" [checked]="riskViewMode == RiskViewMode.CHART" (click)="toggleSideBar()"
                matTooltip="Risk Metric Charts" matTooltipPosition="right">
                <mat-icon>pie_chart</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li> -->
    <!-- <li class="sidebar-group-clear">
        <mat-menu #menu="matMenu" xPosition="before" [overlapTrigger]="false">
            <p-panelMenu class="graphical-view-menu" [model]="categoryItems" [multiple]="false" ></p-panelMenu>
        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Graphical Views" matTooltipPosition="right">
            <mat-icon>view_list</mat-icon>
        </button>
    </li> -->
</ul>
<!-- <div class="layout-tabmenu-contents layout-tabmenu-content layout-tabmenu-content-active">
    <div>
        <p-panelMenu [model]="categoryItems" [multiple]="false"></p-panelMenu>
    </div>
</div> -->
<!-- <ng-container>
    <mat-sidenav-container class="example-container">
        <mat-sidenav #sidenav mode="over" opened="true" class="example-sidenav" [fixedInViewport]="false">

        </mat-sidenav>

        <mat-sidenav-content>
            <p-panelMenu [model]="categoryItems" [multiple]="false"></p-panelMenu>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ng-container> -->